const inappmessaging = {
    banner: {
        height: { value: '150px ' },
        width: { value: '400px ' },
    },
    button: {
        backgroundColor: { value: '#e8e8e8' },
        borderRadius: { value: '5px' },
        color: { value: 'black' },
    },
    dialog: {
        height: { value: '50vh' },
        minHeight: { value: '400px' },
        minWidth: { value: '400px' },
        width: { value: '30vw' },
    },
    header: {
        fontSize: { value: '{fontSizes.medium.value}' },
        fontWeight: { value: '{fontWeights.extrabold.value}' },
    },
};

export { inappmessaging };
